export const MAX_RECORD_TIME = 300 * 60;

// 发送音频数据的间隔
export const SEND_INTERVAL = 40;

// 协议头总字节长度
export const HEADER_LENGTH = 17;

// 每种属性的字节长度
export const MESSAGE_PAYLOAD_BYTE_LENGTH = 4;
export const MESSAGE_TYPE_BYTE_LENGTH = 1;
export const MESSAGE_ID_BYTE_LENGTH = 4;
export const MESSAGE_TIMESTAMP_BYTE_LENGTH = 8;

// 每种属性二进制数据的偏移量
export const MESSAGE_TYPE_OFFSET = 0;
export const MESSAGE_ID_OFFSET = 1;
export const MESSAGE_TIMESTAMP_OFFSET = 5;
export const MESSAGE_PAYLOAD_BYTE_LENGTH_OFFSET = 13;
export const MESSAGE_PAYLOAD_OFFSET = 17;

export enum EMessageType {
  // 连接消息，连接成功后，才可进行推流
  Connect = 20,
  // 服务端通用ACK
  ACK = 22,
  // 暂停推流
  Pause = 24,
  // 继续推流
  Continue = 25,
  // 本次推流结束
  End = 29,
  // 推送PCM音频消息
  PCM = 31,
  // 转录启动
  TranscriberStartup = 101,
  // 转录开始
  SentenceBegin = 102,
  // 转录结束
  SentenceEnd = 103,
  // 转录修正，正在识别的内容
  TranscriptionResultChange = 104,
  // 转录一句话完成, 稳定态
  TranscriptionComplete = 105,
  // 转录完成，添加了声纹识别
  TranscriptionWithSpeakerName = 106,
  // 文本校正
  TranscriptionCorrect = 131,
  // 会中同步前文补充
  TranscriptionSupplement = 132,
  // 会中修改原文
  PersonalModify = 133,
  // 个人端修改发言人之后
  PersonalModifyRole = 134,
  // 个人端清除字幕
  PersonalClearSubtitle = 135,
  // 会中修改原文后，推送过来译文的新的翻译
  TranscriptionUpdateTrans = 136,
  // 智能章节数据推送
  SmartChapter = 108,
  // 智能章节关键帧数据推送
  SmartChapterKeyframe = 109,
  // 转录失败
  TranscriptionFail = 110,
  // 连接限制
  TranscriptionLimit = 111,
  // 第三方服务商认证失败
  TranscriptionAuthFail = 112,
  // 录制权益用尽
  TranscriptionNotEnough = 113,
  // 连接错误
  TranscriptionError = 120,
}

export const ErrorMessagesTypes = [
  EMessageType.TranscriptionLimit,
  EMessageType.TranscriptionAuthFail,
  EMessageType.TranscriptionNotEnough,
  EMessageType.TranscriptionError,
];

export const routesWithoutHeader = [
  "/",
  "/redirect",
  "/share/web",
  "/share/mobile",
];

export const routesWithoutBackground = ["/login"];

export const RuningInLink = window.navigator.userAgent.includes("Electron");

export enum SURPORT_MODEL_ID {
  TingwuSaas = 'tingwu_saas-zh_CN-cn',
  TencentLarge = 'tencent-zh_CN-16k_zh_large',
  TencentZh = 'tencent-zh_CN-16k_zh',
  speechZh = 'speech-zh_CN-zh'
}

export const SURPORT_MODELS = [
  {
    id: SURPORT_MODEL_ID.TingwuSaas,
    label: "通义听悟版本",
  },
  {
    id: SURPORT_MODEL_ID.TencentLarge,
    label: "腾讯大模型版本",
  },
  {
    id: SURPORT_MODEL_ID.TencentZh,
    label: "腾讯中文版本",
  },
  {
    id: SURPORT_MODEL_ID.speechZh,
    label: "思必驰中文版本",
  },
];

export const SURPORT_ENV = [
  {
    id: "prod",
    label: "正式环境",
  },
  {
    id: "uat",
    label: "预发环境",
  },
  {
    id: "test",
    label: "测试环境",
  },
  {
    id: "dev",
    label: "开发环境",
  },
];
